import { Injectable, EventEmitter } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { EntityLicenseModel } from '../../model/entityLicenseModel';
import { ChangeEmployerRequestModel } from '../../model/changeEmployerRequestModel';
import { ChangeEmployerResponseModel } from '../../model/changeEmployerResponseModel';
import { CompleteFunctionResponseModel } from '../../model/completeFunctionResponseModel';
import { CompleteFunctionRequestModel } from '../../model/completeFunctionRequestModel';


@Injectable()
export class ChangeEmployerService {

   
    private notifyEmploymentInformation : EventEmitter<EntityLicenseModel> = new EventEmitter<EntityLicenseModel>();
    private notifySelectedEmployer : EventEmitter<ChangeEmployerResponseModel> = new EventEmitter<ChangeEmployerResponseModel>();
    private notifyAgreement: EventEmitter<boolean> = new EventEmitter<boolean>();

    constructor(private http : HttpClient) { }
   

    getEmploymentInformation(userSessionId : number){
        const params = new HttpParams()
  .set('sessionID', userSessionId.toString());
    return this.http.get<EntityLicenseModel>(environment.server_url+"/api/ChangeEmployer", {params});


    }


    postChangeEmployer(changeEmployerRequestModel:ChangeEmployerRequestModel){
            return this.http.post<ChangeEmployerResponseModel>(environment.server_url+"/api/ChangeEmployer",changeEmployerRequestModel);
    }

    

    getNotifyEmploymentInformation(){
        return this.notifyEmploymentInformation;
    }

    getNotifySelectedEmployer(){
        return this.notifySelectedEmployer;
    }

    getNotifyAgreement(){
        return this.notifyAgreement;
    }

    storeSelectedEmployerData(changeEmployerResponse : ChangeEmployerResponseModel){
        localStorage.setItem('selectedEmployer',JSON.stringify(changeEmployerResponse));
    }

    getSelectedEmployerData(): ChangeEmployerResponseModel{
        if (localStorage.getItem('selectedEmployer') == null || localStorage.getItem('selectedEmployer') == undefined || isEmpty(JSON.parse(localStorage.getItem('selectedEmployer'))))
        return null;
    return JSON.parse(localStorage.getItem('selectedEmployer'));
        
    }
    
    clearSelectedEmployerData():void{
        localStorage.removeItem('selectedEmployer');
    }

    storeEmploymentInfoData(employmentInfo : EntityLicenseModel){
        localStorage.setItem('EmploymentInformation',JSON.stringify(employmentInfo));
    }

    getEmploymentInfoData(): EntityLicenseModel{

        if (localStorage.getItem('EmploymentInformation') == null || localStorage.getItem('EmploymentInformation') == undefined || isEmpty(JSON.parse(localStorage.getItem('EmploymentInformation'))))
        return null;
    return JSON.parse(localStorage.getItem('EmploymentInformation'));
       
    }
    
    clearEmploymentInfoData():void{
        localStorage.removeItem('EmploymentInformation');
    }

    storeAgreementData(agree : boolean){
        if (agree != null || agree != undefined)
            localStorage.setItem('agree', agree.toString());
        localStorage.setItem('agree', null);

    }

    getAgreementData(): boolean{
        if (localStorage.getItem('agree') == null || localStorage.getItem('agree') == undefined || isEmpty(JSON.parse(localStorage.getItem('agree'))))
        return null;
    return JSON.parse(localStorage.getItem('agree'));
         
    }
    
    clearAgreementData():void{
        localStorage.removeItem('agree');
    }
}


    function isEmpty(obj) {
        for(var key in obj) {
            if(obj.hasOwnProperty(key))
                return false;
        }
        return true;
    }


// WEBPACK FOOTER //
// ./src/app/broker/change-employer/change-employer.service.ts